var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageRightEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 191056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 27344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 226",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEC\x82\xAC\xEA\xB0\x81\xED\x98\x95 186",
    d: "M1 1L1 25H25V1H1Z",
    stroke: "#CED4DA"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "ic_page_right_end_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 27345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 31027",
    d: "M13.8 13L9 9L9 17L13.8 13Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEC\x82\xAC\xEA\xB0\x81\xED\x98\x95 16797",
    d: "M16 17H17V9H16V17Z",
    fill: "#212529"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRightEnd);
export default __webpack_public_path__ + "static/media/page_right_end.8bff08ec34025b6df17dc4dcee2f3241.svg";
export { ForwardRef as ReactComponent };